import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b7ab66bc&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=b7ab66bc&prod&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=b7ab66bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab66bc",
  null
  
)

export default component.exports